/* @title App @description Application entry point */
import "popper.js/dist/popper.min.js";

// Bootstrap JS
import "bootstrap/js/dist/util";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/button";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/collapse";
// import "bootstrap/js/dist/tooltip";
import "bootstrap/js/dist/popover";

// import "bootstrap";

// Vendor
import "Vendor/swiper.js";
import "Vendor/resizeimagetoparent.js";

import "litepicker";
import "litepicker/dist/plugins/mobilefriendly";

// Polyfills
import "Utils/_closest.polyfill.js";
import "Utils/_matches.polyfill.js";

// Misc
// Use log() instead of console.log()
// const log = console.log.bind(console);

// Modules
import carouselAccommodation from "Modules/carousel-accommodation/carousel-accommodation";
import carouselAccommodationDetail from "Modules/carousel-accommodation-detail/carousel-accommodation-detail";
import carouselAccommodationDetailImage from "Modules/carousel-accommodation-detail-image/carousel-accommodation-detail-image";
import carouselImmo from "Modules/carousel-immo/carousel-immo";
import carouselHowTo from "Modules/carousel-how-to/carousel-how-to";
import carouselMap from "Modules/carousel-map/carousel-map";
import carouselExpose from "Modules/carousel-expose/carousel-expose";
import carouselImage from "Modules/carousel-image/carousel-image";
import carouselAccountOverview from "Modules/carousel-account-overview/carousel-account-overview";
import carouselGallery from "Modules/carousel-gallery/carousel-gallery";
import carouselPeriod from "Modules/carousel-period/carousel-period";
import carouselImagePreview from "Modules/carousel-image-preview/carousel-image-preview";
import carouselRating from "Modules/carousel-rating/carousel-rating";
import navbar from "Modules/navbar/navbar";
// import datepicker from 'Modules/datepicker/datepicker';
// import searchOverlay from 'Modules/search-overlay/search-overlay';
import "Modules/content/mietpreise";
import "Modules/form-picker/form-picker";

import "Modules/form-guests/form-guests";
import "Modules/filter/filter";
import "Modules/filter/filter-map";
import "Modules/filter/filter-rating";
import "Modules/filter/filter-account-overview";
import "Modules/back-to-top/back-to-top";
import "Modules/history-back/history-back";
import "Modules/selection/selection";
import "Components/input.js";
import "Modules/image-preview/image-preview";
import "Modules/form-modal/form-modal";
import "Modules/list-even-odd/list-even-odd";
import "Modules/contact/contact";
import "Modules/popover/popover";
import "Modules/range/range";
import "Modules/form-additional-service/form-additional-service";
import "Modules/form-additional-service-bed/form-additional-service-bed";
import "Modules/form-additional-service-towel/form-additional-service-towel";
import "Modules/form-calculate/form-calculate";
import "Components/desktop-modal.js";
import "Components/img-resize.js";
import "Components/readmore.js";
import "Components/header-rent-box.js";
import "Components/desktop-collapse.js";
import "Modules/accordion/accordion";
import "Modules/modals/m-saved";
import "Modules/modals/m-chat";
import "Modules/modals/m-newsletter-signup";
import "Modules/modals/m-newsletter-welcome";
import "Modules/modals/m-bestpreis-versprechen-start";
import "Modules/modals/m-booking-detail";
import "Modules/modals/m-booking-confirmation";
import "Modules/modals/m-contact-confirmation";
import "Modules/modals/m-review-confirmation";
import "Modules/modals/modals";
import "Modules/fold-out/fold-out";
import "Modules/clearable/clearable";
import "Modules/input-phone/input-phone";
import "Modules/rating/stars-count";

// Components
// import collapse from 'Components/collapse.js';
// import smoothScroll from 'Components/smooth-scroll';
// import toggleElement from 'Components/toggle-element';
import { Loader } from "@googlemaps/js-api-loader";

const loader = new Loader({
  apiKey: "AIzaSyCXdnbuUJbi7aSW6hposnl0MEVban0jFUI",
  version: "weekly",
  libraries: ["places"],
});

loader
  .load()
  .then((google) => {
    new google.maps.Map(document.getElementById("map-container"), mapOptions);
  })
  .catch(() => {
    // do something
  });

const mapOptions = {
  center: {
    lat: 45.967,
    lng: 8.653,
  },
  mapTypeId: "roadmap",
  zoom: 11,
};

document.addEventListener("DOMContentLoaded", function () {
  // Modules
  carouselAccommodation();
  carouselAccommodationDetail();
  carouselAccommodationDetailImage();
  carouselImmo();
  carouselHowTo();
  carouselMap();
  carouselExpose();
  carouselImage();
  carouselAccountOverview();
  carouselGallery();
  carouselPeriod();
  carouselImagePreview();
  carouselRating();
  navbar();
  // searchOverlay();

  // Components
  // collapse();
  // smoothScroll();
  // toggleElement();
});
